import { render, staticRenderFns } from "./MatchedAcctTrans.vue?vue&type=template&id=d0a63e0e&"
import script from "./MatchedAcctTrans.vue?vue&type=script&lang=js&"
export * from "./MatchedAcctTrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports